export const EVALUATIONS_RESET_STATE = 'EVALUATIONS_RESET_STATE';
export const EVALUATIONS_CURRENT_ITEM = 'EVALUATIONS_CURRENT_ITEM';

export const EVALUATIONS_REQUEST_LOADING = 'EVALUATIONS_REQUEST_LOADING';
export const EVALUATIONS_REQUEST_SUCCESS = 'EVALUATIONS_REQUEST_SUCCESS';
export const EVALUATIONS_REQUEST_FAILED = 'EVALUATIONS_REQUEST_FAILED';

export const EVALUATIONS_CURRENT_ACTION = 'EVALUATIONS_CURRENT_ACTION';
export const EVALUATIONS_RESET_ACTION = 'EVALUATIONS_RESET_ACTION';
